var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "plan-history-modal",
      "size": "xl",
      "hide-footer": "",
      "hide-header-close": ""
    },
    on: {
      "hide": _vm.closeModal
    },
    model: {
      value: _vm.showPlanHistoryModal,
      callback: function callback($$v) {
        _vm.showPlanHistoryModal = $$v;
      },
      expression: "showPlanHistoryModal"
    }
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "platform-title-text text-center mt-3 mb-3"
  }, [_c('h5', [_c('strong', [_vm._v("View Plan History ")])]), _c('div', {
    staticClass: "plan-history-data-wrap mt-3"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Plan Name")]), _c('th', [_vm._v("Carrier")]), _c('th', [_vm._v("Dates")]), _c('th', [_vm._v("Premium Amounts")]), _c('th', [_vm._v("Plan Status")])])]), _c('tbody', [_c('tr', [!_vm.member.plan_history.length ? _c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v(" No records found. ")]) : _vm._e()]), _vm._l(_vm.member.plan_history, function (item, index) {
    return _c('tr', {
      key: index,
      class: {
        termed: item.status.toLowerCase() === 'termed'
      },
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item.plan_name) + " / " + _vm._s(item.tier))]), _c('td', [_vm._v(_vm._s(item.carrier_name))]), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', [_c('strong', [_vm._v("Effective Date:")]), _vm._v(" " + _vm._s(item.plan_effective_date) + " "), _c('br')]), _c('div', [_c('strong', [_vm._v("Termination Date:")]), _vm._v(" " + _vm._s(item.plan_term_date) + " "), _c('br')])]), _c('td', [_vm._v(" $" + _vm._s(item.price))]), _c('td', [_vm._v(" " + _vm._s(item.status) + " "), _c('div', {
      staticClass: "mt-1"
    }, [_vm.canActivate(item.status, item.plan_term_date ? item.plan_term_date : null, item.is_assoc, _vm.member.is_plan_available) ? _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn-activate",
      attrs: {
        "title": "Re-Activate"
      },
      on: {
        "click": function click($event) {
          return _vm.showActivateFormModel(item);
        }
      }
    }, [_c('img', {
      staticClass: "reactive",
      attrs: {
        "src": require("../../../assets/img/re-activate.svg"),
        "alt": ""
      }
    }), _c('span', {
      staticClass: "reactive-txt ml-1"
    }, [_vm._v("Re-activate")])]) : _vm._e()])])]);
  })], 2)])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }